export const CONTACT_CHANNEL_TYPES = {
    EMAIL: 'email',
    LINKEDIN_MESSAGE: 'linkedin',
    LINKEDIN_INMAIL: 'inmail',
    FACEBOOK: 'facebook',
    TALK: 'phone',
};

export const CONTACT_MODE_TYPES = {
    EMAIL: 'email',
    LINKEDIN_MESSAGE: 'message',
    LINKEDIN_INMAIL: 'inmail',
    FACEBOOK: 'facebook',
    TALK: 'phone',
};
